"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    computed: {
        prefList: function () {
            return [
                '北海道',
                '青森県',
                '岩手県',
                '宮城県',
                '秋田県',
                '山形県',
                '福島県',
                '茨城県',
                '栃木県',
                '群馬県',
                '埼玉県',
                '千葉県',
                '東京都',
                '神奈川県',
                '新潟県',
                '富山県',
                '石川県',
                '福井県',
                '山梨県',
                '長野県',
                '岐阜県',
                '静岡県',
                '愛知県',
                '三重県',
                '滋賀県',
                '京都府',
                '大阪府',
                '兵庫県',
                '奈良県',
                '和歌山県',
                '鳥取県',
                '島根県',
                '岡山県',
                '広島県',
                '山口県',
                '徳島県',
                '香川県',
                '愛媛県',
                '高知県',
                '福岡県',
                '佐賀県',
                '長崎県',
                '熊本県',
                '大分県',
                '宮崎県',
                '鹿児島県',
                '沖縄県',
            ].map(function (s) { return ({ value: s, label: s }); });
        },
        industryList: function () {
            return [
                "看護師",
                "理学療法士",
                "言語聴覚士",
                "作業療法士",
            ].map(function (s) { return ({ value: s, label: s }); });
        },
        triggerList: function () {
            return [
                '友人・知人などの紹介',
                'インターネット検索（検索ワード）',
                'チラシ',
                'SNS（X・Instagram・Facebook）',
                'YouTube',
                'その他'
            ].map(function (s) { return ({ value: s, label: s }); });
        },
    }
});
